import { Fragment } from 'react';

/**
 * Renders mixed text where only the figures get the numeric role.
 * "45 kg · Indoor" → <num>45</num> kg · Indoor; "CAD 2,550/g" → CAD <num>2,550</num>/g.
 * Labels, units, currency codes and descriptors stay in the UI face.
 */
const FIGURE = /(\d[\d,.]*%?)/g;

export function splitFigures(text: string): { value: string; figure: boolean }[] {
  return text
    .split(FIGURE)
    .filter((s) => s !== '')
    .map((value) => ({ value, figure: /^\d/.test(value) }));
}

export function NumText({
  children,
  role = 'num',
}: {
  children: string | number | null | undefined | false;
  role?: 'num' | 'num-cell' | 'num-metric';
}) {
  if (children === null || children === undefined || children === false) return null;
  return (
    <>
      {splitFigures(String(children)).map((part, i) =>
        part.figure ? (
          <span key={i} className={role}>{part.value}</span>
        ) : (
          <Fragment key={i}>{part.value}</Fragment>
        ),
      )}
    </>
  );
}
